import script from "./PandoraCardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraCardItem.vue?vue&type=script&setup=true&lang=js"

import "./PandoraCardItem.vue?vue&type=style&index=0&id=073c5f7e&lang=css"

const __exports__ = script;

export default __exports__